<ion-header>
    <ind-page-title [viewData]='{id:"veeva-widget",title: veeva.widgetTitle}' (onControlClick)='onPageTitleControlClick($event)'></ind-page-title>
</ion-header>
<ion-content>
</ion-content>
<!-- <ion-footer> -->
<footer-toolbar *ngIf="footerService.shouldShowFooter$ | async" [footerView]="'detailView'" [selectedView]="'veeva-contact'"></footer-toolbar>
<!-- </ion-footer> -->